import * as React from "react";
import {Grid} from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import Catalogo from "../../components/Catalogo";
import {ProveedoresForm }  from "../../Catalogos";
import { GetRoles } from "../../herramientas/JWT";
function ProveedoresPage() {
  if(!GetRoles().includes("root",))
    window.history.back();
  return (
    <SiteWrapper>
        <Grid.Col sm={12} lg={12}> 
          <Catalogo
            titulo="Proveedores"
            tamanio="65%"
            FCtlogo= { ProveedoresForm }
            catalogo= "proveedores"
            columnas= {
              [
                { columna: "id", label:"ID" },
                { columna: "nombre", label:"NOMBRE" },
                { columna: "url", label:"URL" },
                { columna: "puerto", label:"PUERTO" },
              ]
            }
          />
        </Grid.Col>
    </SiteWrapper>
  );
}
export default ProveedoresPage;
